// extracted by mini-css-extract-plugin
module.exports = {"logo":"BurgerKingLogo-module--logo--3TEdb"};